// 面向对象语言不能以数字开头，所以和后台约定，ws字段slot前面加s,比如s3代表第三号机位
const slotPrefix = 's';

// 开发环境的ws配置
//const devWs = 'http://pprecord.tvunetworks.com/filebackend'
//const devWs = "https://file-test.tvunetworks.com/filebackend";

// const devWs = 'https://file.tvunetworks.com/filebackend'
// const devWs = 'https://pprecord.cinctech.com'
// for testing
// const markerApiUrl =
//   "https://recordfile-test.tvunetworks.com/tvu/MeatadataService";
// for production
//const markerApiUrl = "https://recordfile.tvunetworks.com/tvu/MeatadataService";

// for CN environment;
//const markerApiUrl = "https://recordfile.tvunetworks.cn/tvu/MeatadataService";

// const devWs = 'http://pprecord.tvunetworks.com/filebackend'
// const devWs = "https://file-test.tvunetworks.com/filebackend";
// const devWs = 'https://file.tvunetworks.com/filebackend'
//const devWs = "https://pprecord.cinctech.com";

// for test prod-c env
// const devWs = "https://file-test.tvunetworks.com/filebackend"
// const markerApiUrl = "https://recordfile-test.tvunetworks.com/tvu/MeatadataService"

// prod2 env config
// const devWs = "https://file.tvunetworks.com/filebackend"
// const markerApiUrl = "https://recordfile.tvunetworks.com/tvu/MeatadataService";

// Test-A env
//  const devWs = 'https://file-test.tvunetworks.com/filebackend';
//  const markerApiUrl =
//   'https://recordfile-test.tvunetworks.com/tvu/MeatadataService';
//  const uservice = 'https://userservice.tvunetworks.com/userAuth';
//  const userAuth = 'userservice.tvunetworks.com/userAuth';
//  const gatewayUrl = 'https://gateway-test.tvunetworks.com';
//  const newloginservice = 'userservice.tvunetworks.com/newloginservice/';
//  const trimmerTool = `https://tool.tvunetworks.com/iframe.html`;


// // for CN environment; //
// const devWs = "https://pprecord.cinctech.com";
const devWs = 'https://file-test.tvunetworks.cn/filebackend';
const markerApiUrl = "https://recordfile.tvunetworks.cn/tvu/MeatadataService";
const uservice = 'https://userservice.tvunetworks.cn/userAuth';
const userAuth = 'userservice.tvunetworks.cn/userAuth';
const gatewayUrl = 'https://gateway.tvunetworks.cn/';
const newloginservice = 'userservice.tvunetworks.cn/newloginservice/';
const trimmerTool = `https://tool.tvunetworks.cn/iframe.html`;

const environment = 'dev';
exports.default = { slotPrefix, devWs, uservice };
exports.slotPrefix = slotPrefix;
exports.devWs = devWs;
exports.apiUrl = markerApiUrl;
exports.gatewayUrl = gatewayUrl;
exports.newloginservice = newloginservice;
exports.uservice = uservice
exports.userAuth = userAuth
// exports.publicPath = publicPath;
exports.__esModule = true;
exports.environment = environment;
